import React from 'react';
import { motion } from 'framer-motion';
import { Wrench, Sparkles, TrendingUp, Award, CheckCircle2, Briefcase } from 'lucide-react';
const cards = [{
  icon: Wrench,
  title: 'Querés aprender un oficio rentable',
  desc: 'Desarrollá una habilidad con alta demanda constante.'
}, {
  icon: Sparkles,
  title: 'Querés empezar desde cero',
  desc: 'Sin conocimientos previos, paso a paso.'
}, {
  icon: TrendingUp,
  title: 'Querés generar ingresos reales',
  desc: 'Convertí tu conocimiento en una fuente de dinero.'
}, {
  icon: Award,
  title: 'Querés profesionalizarte',
  desc: 'Dejá de improvisar y trabajá con criterio técnico.'
}, {
  icon: CheckCircle2,
  title: 'Ya hacés trabajos pero querés hacerlo bien',
  desc: 'Actualizate y aplicá la normativa vigente.'
}, {
  icon: Briefcase,
  title: 'Querés independizarte económicamente',
  desc: 'Sé tu propio jefe y manejá tus tiempos.'
}];
export function WhoIsFor() {
  return <section className="py-24 bg-ed-black relative border-t border-white/5" data-id="element-541">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-542">
        <div className="text-center mb-16" data-id="element-543">
          <span className="text-ed-green font-bold tracking-widest uppercase text-sm mb-3 block" data-id="element-544">
            Para quién es
          </span>
          <h2 className="text-4xl sm:text-5xl font-black uppercase tracking-tight text-white" data-id="element-545">
            ¿Esta formación es para vos?
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-546">
          {cards.map((card, i) => {
          const Icon = card.icon;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5,
            delay: i * 0.1
          }} className="bg-ed-dark border border-zinc-800/80 rounded-2xl p-6 hover:border-ed-green/30 transition-colors group" data-id="element-547">
                <div className="w-12 h-12 rounded-xl bg-ed-black border border-zinc-800 flex items-center justify-center mb-5 group-hover:glow-green-sm transition-all" data-id="element-548">
                  <Icon className="w-6 h-6 text-ed-green" data-id="element-549" />
                </div>
                <h3 className="text-xl font-bold text-white mb-2 leading-tight" data-id="element-550">
                  {card.title}
                </h3>
                <p className="text-zinc-400 text-sm" data-id="element-551">{card.desc}</p>
              </motion.div>;
        })}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto bg-ed-dark border-l-4 border-ed-green rounded-r-xl p-6 sm:p-8 shadow-2xl" data-id="element-552">
          <p className="text-lg sm:text-xl font-medium text-zinc-300 text-center" data-id="element-553">
            <span className="text-ed-yellow font-black" data-id="element-554">NO</span> necesitás
            experiencia previa. <br className="sm:hidden" data-id="element-555" />
            <span className="text-ed-yellow font-black sm:ml-2" data-id="element-556">NO</span>{' '}
            necesitás conocimientos técnicos.
          </p>
        </motion.div>
      </div>
    </section>;
}